import { Component, OnInit, ViewChild } from '@angular/core';
import { Select2OptionData } from 'ng2-select2';
import { Beneficiary } from '../../shared/models/beneficiary.model';
import { BeneficiaryService } from '../../shared/services/beneficiary.service';
import { SessionService } from '../../shared/services/session.service';
import { LaboratoryTestsListComponent } from './laboratory-tests-list/laboratory-tests-list.component';
import { ModalSecurityQuestionsComponent } from './modals/modal-security-questions/modal-security-questions.component';

@Component({
  selector: 'app-laboratory-tests',
  templateUrl: './laboratory-tests.component.html',
  styleUrls: ['./laboratory-tests.component.css']
})
export class LaboratoryTestsComponent implements OnInit {

  @ViewChild(ModalSecurityQuestionsComponent) modalSecurityQuestionsComponent: ModalSecurityQuestionsComponent;

  @ViewChild(LaboratoryTestsListComponent) laboratoryTestsListComponent: LaboratoryTestsListComponent;

  public beneficiarios: Select2OptionData[];

  public  contratoSeleccionado: string;

  showSpinnerBeneficiarios: boolean;

  public documentTypeBeneficiary: string;

  public documentIdBeneficiary: string;


  constructor(private _sessionService: SessionService,
    private _beneficiaryService: BeneficiaryService,) 
    { }


  ngOnInit() {
    this.contratoSeleccionado = this._sessionService.getSelectContract();
    let documentId = this._sessionService.getCurrentUser().documentId;
    let documentType = this._sessionService.getSelectDocumentTypeContracted();
    this.getBeneficiariesContract(this.contratoSeleccionado, documentId, documentType);
  }


  public getBeneficiariesContract(contractSelect: string, documentId: string, documentType: string) {
    this.showSpinnerBeneficiarios = true;
    this._beneficiaryService.getBeneficiariesContract(contractSelect, documentId, documentType).subscribe(
      res => {

        let _res: any[];


        /*
        if(this._sessionService.getCurrentUser().userType == "M" && this._sessionService.getCurrentUser().age >= 18) {
          let j: number;
          j = 0;
          var _array = [];

          for (let usuario of res) {
            if (usuario.edad < 18) {
              _array.push(usuario);
            }
            j++;
          }

          _res = this.toSelect2(_array);
        }
        else if(this._sessionService.getCurrentUser().userType == "B" && this._sessionService.getCurrentUser().age >= 18) {
          let j: number;
          j = 0;
          var _array = [];

          for (let usuario of res) {
            if (usuario.documentoIdentidad == this._sessionService.getCurrentUser().documentId || usuario.edad < 18) {
              _array.push(usuario);
            }
            j++;
          }

          _res = this.toSelect2(_array);
        }
        else if(this._sessionService.getCurrentUser().userType == "B" && this._sessionService.getCurrentUser().age < 18) {
          let j: number;
          j = 0;
          var _array = [];

          for (let usuario of res) {
            if (usuario.documentoIdentidad == this._sessionService.getCurrentUser().documentId) {
              _array.push(usuario);
            }
            j++;
          }

          _res = this.toSelect2(_array);
        }
        */
        


        
        //Usuario menor de edad
        if (this._sessionService.getCurrentUser().age < 18) {
          let i: number;
          i = 0;
          for (let usuario of res) {
            if (usuario.documentoIdentidad === this._sessionService.getCurrentUser().documentId) {
              _res = this.toSelect2(Array<Beneficiary>(res[i]));
            }
            i++;
          }
        }
        else {
          let j: number;
          j = 0;
          var _array = [];

          for (let usuario of res) {
            if (usuario.estado === 'ACTIVO') {
              _array.push(usuario);
            }
            j++;
          }

          _res = this.toSelect2(_array);
        }
        

        let _optionDefault = this.getOptionDefault('Seleccione un solicitante...');
        let _optionBeneficiarios = _res;
        let _options = _optionDefault.concat(_optionBeneficiarios);
        this.showSpinnerBeneficiarios = false;
        this.beneficiarios = _options;
      },
      err => {
        this.showSpinnerBeneficiarios = false;
        console.log(err);
      }

    );
  }


  toSelect2(source: Beneficiary[]): any[] {
    var _array = [];

    for (let s of source) {
      let _obj = {
        id: s.documentoIdentidad,
        text: s.documentoIdentidad + ' - ' + s.nombre,
        documentType: s.tipoIdentificacion4,
      };
      _array.push(_obj);
    }

    return _array;
  }


  getOptionDefault(texto: string): any[] {
    return [{ id: '-1', text: texto }];
  }


  public changedBeneficiary(event) {
    this.documentTypeBeneficiary = event.data[0].documentType;
    this.documentIdBeneficiary = event.data[0].id;
    this.modalSecurityQuestionsComponent.showDialog(this.documentTypeBeneficiary, this.documentIdBeneficiary);
    //this.laboratoryTestsListComponent.getLaboratoryTests(this.documentTypeBeneficiary, this.documentIdBeneficiary);
  }


  public getUserAnswers(userAnswers: boolean) {
    if(userAnswers) {
      this.laboratoryTestsListComponent.getLaboratoryTests(this.documentTypeBeneficiary, this.documentIdBeneficiary);
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/office/laboratory-tests/laboratory-tests.component.ts